/**
 * Utility function to track Heap / Data Dog. Heap events will have a specific naming convention (AppName - Location - Action - Object)
 * AppName will always be Borg AEMP Integrations in this package.
 * Location is where the event occurs.
 * Action is the event that occurs, i.e. a click.
 * Object is where the event happened, i.e. on a specific button or field.
 * Props are optional properties, stored as an object, to be sent with the event.
 */
import { datadogRum } from '@datadog/browser-rum'
import { type Maybe } from '../graphql/generated/generated'

export const ANALYTICS_LOCATIONS = {
	ACTIVE_INTEGRATIONS: 'Active Integrations',
	AVAILABLE_INTEGRATIONS: 'Available Integrations',
	MANAGE_PAGE: 'Manage Page',
	CREATE_PAGE: 'Create Page',
}

export const appendJDLinkToHeapLocation = ( location: string, integrationTitle: Maybe<string> = '' ): string => {
	if ( integrationTitle?.includes( 'John Deere Link' ) ) {
		return `${location} (JDLink)`
	}

	return location
}

export const trackAnalyticEvent = (
	location: string,
	action: string,
	object: string,
	props?: Record<string, unknown>,
): void => {
	const appName = 'Borg AEMP Integrations'
	const eventName = `${appName} - ${location} - ${action} - ${object}`

	window.heap.track( eventName, props )
	datadogRum.addAction( eventName, props )
}
